<template>
  <div id="informationEntryOfCurrent">
    <div class="Grid85004776">
      <div class="Grid3CFB3B2B">
        <div>
          <md-field-item
            :content="SelectorBox6ECF.content"
            :title="$t('label.label98')"
            :placeholder="$t('label.label179')"
            :arrow="true"
            :solid="true"
            :align="'right'"
            @click="SelectorBox6ECF.value=true"
          >
          </md-field-item>
          <md-picker
            v-model="SelectorBox6ECF.value"
            :title="$t('label.label98')"
            :cancel-text="$t('btn.btn2')"
            :ok-text="$t('btn.btn1')"
            :data="SelectorBox6ECF.data"
            ref="picker1"
            :cols="1"
            @confirm="chooseSelectorBox6ECF"
          >
          </md-picker>
        </div>
        <div>
          <md-field-item
            :content="SelectorBox97E8.content"
            :title="$t('label.label108')"
            :placeholder="$t('label.label187')"
            :arrow="true"
            :solid="true"
            :align="'right'"
            @click="SelectorBox97E8.value=true"
          >
          </md-field-item>
          <md-picker
            v-model="SelectorBox97E8.value"
            :title="$t('label.label108')"
            :data="SelectorBox97E8.data"
            ref="picker2"
            :cols="1"
            :cancel-text="$t('btn.btn2')"
            :ok-text="$t('btn.btn1')"
            @confirm="chooseSelectorBox97E8"
          >
          </md-picker>
        </div>
        <div>
          <md-field-item
            :content="SelectorBoxB14C.content"
            :title="$t('label.label109')"
            :placeholder="$t('label.label189')"
            :arrow="true"
            :solid="true"
            :align="'right'"
            @click="SelectorBoxB14C.value=true"
          >
          </md-field-item>
          <md-picker
            v-model="SelectorBoxB14C.value"
            :title="$t('label.label109')"
            :data="SelectorBoxB14C.data"
            ref="picker3"
            :cols="1"
            :cancel-text="$t('btn.btn2')"
            :ok-text="$t('btn.btn1')"
            @confirm="chooseSelectorBoxB14C"
          >
          </md-picker>
        </div>
        <div>
          <md-input-item
            :type="'text'"
            v-model="InputItem56A1.value"
            @blur="InputItem56A1Blur"
            :title="$t('label.label107')"
            :placeholder="$t('label.label190')"
          />
        </div>
      </div>
      <div class="Grid3BD34410">
        <span text="'存入金额（元）'" class="textF0892176">
          {{$t('label.label101')}}
        </span>
        <md-input-item
          :type="'text'"
          v-model="InputItem56A2.value"
          @blur="inputBlur"
          :placeholder="$getFormat($t('label.label102'),minValue)"
          clearable
        />
        <div class="GridE89DD886">
          <span text="'账户当前可用余额MOP 10,000.00'" class="text6D2D4F7E">
            {{$t('label.label105')}}{{payCcy}} {{$commafy(availableBalance)}}
          </span>
          <span text="'全部存入'" class="text33DFC870" @click="allIn">
            {{$t('label.label104')}}
          </span>
        </div>
      </div>
      <div class="GridCB5CCE6B">
        <md-agree
          :text="'我已閱讀協議條款，清楚並同意該協議條款。'"
          v-model="Agree8723.value"
        >{{$t('label.label106')}}
          <a class="argus" :class="{engFont: this.$i18n.locale === 'en'}"  @click="browseTheArgument">{{$t('label.label214')}}</a>
          {{$t('label.label213')}}
          <a  v-if="this.$i18n.locale !== 'en'">{{$t('label.label214')}}</a>
        </md-agree>
      </div>
      <div class="Grid39DAC6A9">
        <md-button :text="'确定'" :type="'primary'" :round="true" @click="buyPro">{{$t('btn.btn1')}}</md-button>
      </div>
    </div>
    <div class="dialogArea">
      <md-dialog
        v-model="showDialog"
        :closable="true"
        :mask-closable="true"
      >

        <div class="textArea">
          <!--   定期       -->
          <p>{{$t('argument.argument24')}}</p>
          <br>
          <p>{{$t('argument.argument25')}}</p>
          <br>
          <p>{{$t('argument.argument26')}}</p>
          <br>
          <p>{{$t('argument.argument27')}}</p>
          <br>
          <p>{{$t('argument.argument28')}}</p>
          <br>
          <p>{{$t('argument.argument29')}}</p>
          <br>
          <p>{{$t('argument.argument30')}}</p>
          <br>
          <p>{{$t('argument.argument31')}}</p>
          <br>
          <p>{{$t('argument.argument32')}}</p>
        </div>
      </md-dialog>
    </div>
  </div>
</template>
<script>
import { FieldItem, Picker, InputItem, Agree, Button, Toast, Dialog } from '@gidc/mobile'
import { BILLACCOUNTNO, EBANKBALANCESELECT, USERACCLIST } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'informationEntryOfCurrent',
  components: {
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Agree.name]: Agree,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [Dialog.name]: Dialog
  },
  computed: {
    ...mapGetters([
      'buyProInfo',
      'RnInfo',
      'proInfo'
    ])
  },
  data () {
    return {
      SelectorBox6ECF: {
        content: '',
        value: false,
        data: [[]]
      },
      SelectorBox97E8: {
        content: '',
        value: false,
        data: [[]]
      },
      SelectorBoxB14C: {
        content: '',
        value: false,
        data: [[
          {
            text: 'D1-每天派息',
            value: 'D1'
          },
          {
            text: 'M1-每月派息',
            value: 'M1'
          },
          {
            text: 'M3-每季度派息',
            value: 'M3'
          },
          {
            text: 'M6-每半年派息',
            value: 'M6'
          }
        ]]
      },
      InputItem56A0: {
        value: ''
      },
      InputItem56A1: {
        value: ''
      },
      InputItem56A2: {
        value: ''
      },
      Agree8723: {
        value: false
      },
      availableBalance: '', // 余额
      accID: '',
      payCcy: '',
      inputAmt: '',
      phone: '',
      SelectorBoxB14CValue: '',
      accList: [], // 账户列表
      buyCcy: '', // 购买币种
      payAcctNo: '', // 真是卡号
      minValue: '',
      showDialog: false
    }
  },
  methods: {
    buyPro () {
      const InputItem56A2 = this.$delcommafy(this.InputItem56A2.value)
      const InputItem56A1 = this.$delcommafy(this.InputItem56A1.value)
      const reg = /^\d+(?=\.{0,1}\d+$|$)/
      if (InputItem56A2 === '') {
        Toast.info(this.$t('label.label182'))
      } else if (!reg.test(InputItem56A2)) {
        Toast.info(this.$t('label.label183'))
      } else if (parseInt(InputItem56A2) < parseInt(this.minValue)) {
        Toast.info(this.$getFormat(this.$t('label.label102'), this.minValue))
      } else if (!this.Agree8723.value) {
        Toast.info(this.$t('label.label184'))
      } else if (this.SelectorBoxB14C.content === '') {
        Toast.info(this.$t('label.label189'))
      } else if (InputItem56A1 === '') {
        Toast.info(this.$t('label.label182'))
      } else if (!reg.test(InputItem56A1)) {
        Toast.info(this.$t('label.label183'))
      } else if (this.SelectorBox97E8.content === '') {
        Toast.info(this.$t('label.label187'))
      } else {
        const params = {
          InputItem56A2: this.$delcommafy(this.InputItem56A2.value),
          Agree8723: this.Agree8723.value,
          SelectorBoxB14C: this.SelectorBoxB14C.content,
          SelectorBoxB14CValue: this.SelectorBoxB14CValue,
          InputItem56A1: this.$delcommafy(this.InputItem56A1.value),
          SelectorBox6ECF: this.SelectorBox6ECF.content,
          SelectorBox97E8: this.payAcctNo,
          availableBalance: this.availableBalance,
          ccy: this.SelectorBox6ECF.content,
          accID: this.accID,
          payCcy: this.payCcy,
          prodClass: this.buyProInfo.prodClass
        }
        this.$store.commit('proInfo', params)
        this.$router.push({ name: 'informationConfirmOfCurrent' })
      }
    },
    allIn () {
      this.InputItem56A2.value = this.$commafy(this.availableBalance)
    },
    InputItem56A1Blur () {
      this.InputItem56A1.value = this.$commafy(this.InputItem56A1.value)
    },
    inputBlur () {
      this.InputItem56A2.value = this.$commafy(this.InputItem56A2.value)
    },
    getAccNo () {
      const resParams = {
        id: this.accID
      }
      this.$remote.post(BILLACCOUNTNO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), resParams, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.payAcctNo = res.accountNo
          this.showBalanceClick()
        })
    },
    showBalanceClick () {
      const params = {
        accountNo: this.accID,
        paymentCurrency: this.payCcy,
        reccivingCurrency: 'CNY'
      }
      this.$remote.post(EBANKBALANCESELECT + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.availableBalance = res.availableBalance
        })
    },
    getAccNoList () {
      const params = {}
      this.$remote.post(USERACCLIST + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          res.list.forEach(item => {
            item = { text: item.currency + '-' + item.accountCoreNo, value: item.id, currency: item.currency }
            this.SelectorBox97E8.data[0].push(item)
            this.accList.push(item)
          })
          this.SelectorBox97E8.data[0] = this.SelectorBox97E8.data[0].filter(item => item.currency === this.buyProInfo.ccy.value)
          console.log('this is SelectorBoSelectorBox97E8xB14C', this.SelectorBox97E8.data[0])
          if (this.SelectorBox97E8.data[0].length > 0) {
            this.SelectorBox97E8.content = this.SelectorBox97E8.data[0][0].text
            this.payCcy = this.SelectorBox97E8.data[0][0].currency
            this.accID = this.SelectorBox97E8.data[0][0].value
            this.initData()
            this.getAccNo()
          } else {
            this.SelectorBox97E8.content = ''
            this.payCcy = ''
            this.accID = ''
            Toast.info(this.$t('label.label200'))
          }
        })
    },
    chooseSelectorBox6ECF (obj) {
      // this.SelectorBox6ECF.content = obj[0].text
      // console.log(this.SelectorBox6ECF.content)
      this.buyCcy = obj[0].text
      this.SelectorBox6ECF.content = obj[0].text
      console.log('thsi i s buyccy', this.buyCcy)
      const list = this.accList.filter(item => item.currency === this.buyCcy)
      this.SelectorBox97E8.data.splice(0, 1, list)
      console.log('this is SelectorBox97E8', this.SelectorBox97E8.data[0])
      if (this.SelectorBox97E8.data[0].length > 0) {
        this.SelectorBox97E8.content = this.SelectorBox97E8.data[0][0].text
        this.payCcy = this.SelectorBox97E8.data[0][0].currency
        this.accID = this.SelectorBox97E8.data[0][0].value
        this.getAccNo()
      } else {
        this.SelectorBox97E8.content = ''
        this.payCcy = ''
        this.accID = ''
        Toast.info(this.$t('label.label200'))
      }
    },
    chooseSelectorBox97E8 (obj) {
      console.log(obj)
      this.payCcy = obj[0].currency
      this.accID = obj[0].value
      this.SelectorBox97E8.content = obj[0].text
      this.showBalanceClick()
    },
    chooseSelectorBoxB14C (obj) {
      this.SelectorBoxB14C.content = obj[0].text
      this.SelectorBoxB14CValue = obj[0].value
    },
    initData () {
      if (this.proInfo !== '') {
        this.SelectorBox6ECF.content = this.proInfo.SelectorBox6ECF
        this.SelectorBox6ECF.data.splice(0, 1, this.buyProInfo.cycResultList)
        this.SelectorBoxB14C.content = this.proInfo.SelectorBoxB14C
        this.InputItem56A1.value = this.proInfo.InputItem56A1
        this.InputItem56A2.value = this.proInfo.InputItem56A2
        this.$store.commit('proInfo', '')
        this.buyCcy = this.SelectorBox6ECF.content
        const list = this.accList.filter(item => item.currency === this.buyCcy)
        this.SelectorBox97E8.data.splice(0, 1, list)
        console.log('this is SelectorBox97E8dsfsfds', this.SelectorBox97E8.data, 'buyCcy', this.buyCcy)
        this.SelectorBox97E8.content = this.SelectorBox97E8.data[0][0].text
        this.payCcy = this.SelectorBox97E8.data[0][0].currency
        this.accID = this.SelectorBox97E8.data[0][0].value
      } else {
        this.SelectorBox6ECF.content = this.buyProInfo.ccy.value
        this.SelectorBox6ECF.data.splice(0, 1, this.buyProInfo.cycResultList)
        this.minValue = this.buyProInfo.minValue
      }
      // this.SelectorBox97E8.data.splice(0, 1, this.buyProInfo.cycleList)
    },
    browseTheArgument () {
      this.showDialog = true
    }
  },
  mounted () {
    this.getAccNoList()
  }
}
</script>
<style lang="stylus">
  #informationEntryOfCurrent{
    .Grid85004776{
      .Grid3CFB3B2B{
        .md-field-item{
          .md-field-item-content{
            min-height .92rem
            height .92rem
            .md-field-item-title{
              font-size .28rem
              font-weight 400
              color #1E1E1E
              line-height .4rem
              text-align left
            }
            .md-field-item-control{
              height .4rem
              font-size .28rem
              font-weight 400
              color #333333
              line-height .4rem
              input{
                height 40px
                font-size 28px
                font-weight 400
                color #333333
                line-height 40px
                text-align right
              }
              input::placeholder {
                      color #999999
                      font-weight 400
                      font-size .28rem
                      height .4rem
                      line-height .4rem
                    }
              .md-field-item-placeholder{
                height .4rem
                font-size .28rem
                font-weight 400
                color #999999
                line-height .4rem
              }
            }
          }
        }
      }
      .Grid3BD34410{
        .md-field-item{
          padding .3rem 0
          .md-field-item-content{
            height .4rem
            min-height .4rem
            width 4rem
            .md-field-item-control{
              padding 0 .3rem
              .md-input-item-input{
                font-weight 400
                color #333333
                font-size .28rem
                height .4rem
                line-height .4rem
              }
              input::placeholder {
                      color #999999
                      font-weight 400
                      font-size .28rem
                      height .4rem
                      line-height .4rem
                    }
            }
          }
          .md-field-item-content::before{
            content none
          }
        }
      }
      .Grid39DAC6A9{
        .md-button{
          height .92rem
          min-height .9rem
          .md-button-inner{
            .md-button-content{
              height .5rem
              font-size .36rem
              font-weight 500
              color #FFFFFF
              line-height .5rem
            }
          }
        }
        .md-button.primary{
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)
          border-radius .46rem
        }
      }
    }
    .md-popup-box{
      .md-popup-title-bar{
        .title-bar-left{
          width auto
        }
        .title-bar-right{
          width auto
        }
      }
    }
  }
  .md-dialog-body{
    padding .52rem
    height 70vh
    overflow auto !important
    .md-icon.icon-font:before{
      top -.15rem
      left .15rem
    }
  }
  .md-icon.icon-font.md{
    font-size .5rem
  }
</style>
<style lang="stylus" scoped>
  #informationEntryOfCurrent{
    .Grid85004776{
      .Grid3CFB3B2B{
        padding 0 .3rem
      }
      .Grid3BD34410{
        position relative
        padding .3rem
        .textF0892176{
          font-size .28rem
          display block
          font-weight 400
          height .4rem
          line-height .4rem
          color #1E1E1E
        }
        .GridE89DD886{
          display flex
          justify-content space-between
          .text6D2D4F7E{
            display inline-block
            font-size .28rem
            height .4rem
            font-weight 400
            color #1E1E1E
            line-height .4rem

          }
          .text33DFC870{
            display inline-block
            font-size .28rem
            font-weight 400
            color #3A56D8
            line-height .4rem
          }
        }
      }
      .Grid3BD34410::after{
        position absolute
        bottom 0
        content ''
        width 92%
        height .02rem
        background #ECECEC
      }
      .GridCB5CCE6B{
        font-size .2rem
        font-weight 400
        color #999999
        line-height .28rem
        padding .3rem
        .argus{
          color #2f86f6
        }
        .engFont{
          font-style italic
        }
      }
      .Grid39DAC6A9{
        padding .6rem .3rem .3rem
      }
    }
    .dialogArea{
      .textArea{
        padding: .3rem .3rem;
        display: block;
        border-radius: 10px;
        word-wrap: break-word;
        font-size: .25rem;
        background: rgba(247, 247, 247, 0.7);
        margin .16rem .32rem .54rem
      }
    }
  }
</style>
